<template>
    <div>
        <b-modal id="modal-log" :title="title" size="xl"
            no-close-on-backdrop no-close-on-esc hide-footer
            @shown="init"
            @hidden="checkIfShouldRefresh"
        >
            <b-form-row>
                <b-col md="1" class="my-auto">Tipe</b-col>
                <b-col>
                    <b-form-checkbox-group v-model="filter.tipeLog" :options="optLog" />
                </b-col>
            </b-form-row>
            <b-form-row class="mt-2">
                <b-col md="1" class="my-auto">Tanggal</b-col>
                <b-col md="2">
                    <b-input type="date" v-model="filter.start" />
                </b-col>
                <b-col md="auto" class="my-auto">s/d</b-col>
                <b-col md="2">
                    <b-input type="date" v-model="filter.end" />
                </b-col>
                <b-col md="2">
                    <b-form-select v-model="filter.sort" :options="optSort" />
                </b-col>
                <b-col md="auto">
                    <b-button variant="primary" class="mr-2" @click="getItems(1)">
                        <i class="fa fa-search mr-2" /> Cari
                    </b-button>
                    <b-button variant="danger" @click="filter.start = null; filter.end = null">
                        <i class="fa fa-times mr-2" /> Hapus Tanggal
                    </b-button>
                    <b-button v-if="isAllowedToDownloadExcel()" variant="success" class="ml-2" @click="$bvModal.show('modal-excel-log')">
                        <i class="fa fa-download mr-2" /> Excel
                    </b-button>
                </b-col>
            </b-form-row>
            <b-table
                bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada catatan.
                </template>
                <template v-slot:cell(createdAt)="row">
                    {{ $helper.parseDate(row.item.createdAt) }}
                    <div class="small text-muted">{{ $helper.parseHourMinute(row.item.createdAt) }}</div>
                </template>
                <template v-slot:cell(pengerjaan)="row">
                    {{ $helper.parseDate(row.item.tanggalPengerjaan) }}
                    <div class="small text-muted">{{ row.item.lokasi }}, {{ row.item.wilayah }}</div>
                </template>
                <template v-slot:cell(tipe)="row">
                    <b-badge :variant="parseBadgeVariantTipe(row.item.tipe.id)">{{ row.item.tipe.name }}</b-badge>
                    <div class="small text-muted">{{ row.item.createdBy }}</div>
                </template>
                <template v-slot:cell(catatan)="row">
                    <strong>{{ row.item.headline }}</strong>
                    <br />
                    <span style="white-space: pre-line" v-html="row.item.keterangan" />
                </template>
                <template v-slot:cell(aksi)="row">
                    <b-button variant="danger" size="sm" v-b-tooltip.hover title="Void" @click="openVoidModal(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-modal>
        <b-modal id="modal-void" title="Void Log" centered
            no-close-on-backdrop no-close-on-esc hide-footer
        >
            Void log ini? Log yang sudah divoid akan dihapus, dan data engine akan dikembalikan seperti sebelum log ini dibuat.
            <b-alert variant="warning" class="mt-3" show>
                <strong>Peringatan!</strong> Log yang sudah divoid / dihapus tidak dapat dikembalikan lagi!
            </b-alert>
            <div class="text-right">
                <b-btn variant="danger" :disabled="isSubmitting" @click="executeVoid">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Void' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-excel-log" title="Cetak Excel" centered no-close-on-esc no-close-on-backdrop hide-footer @hidden="printStatus = 0">
            <div v-if="printStatus == 0">
                <div>Generate excel dengan log sesuai dengan filter yang digunakan sekarang?</div>
                <b-button class="mt-2" variant="success" @click="executeDownloadExcel">Download</b-button>
            </div>
            <div v-else-if="printStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark"></b-spinner>
                <div class="mt-2">Mohon menunggu...</div>
            </div>
            <div v-else-if="printStatus == 2">
                <div class="mb-2">Excel siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="excelPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'logs',
    props: {
        main: { type: Object, required: true },
        title: { type: String, required: true }
    },
    data() {
        return {

            roleId: 1,
            hasVoid: false,
            printStatus: 0,
            excelPath: "",

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                tipeLog: [],
                start: null,
                end: null,
                sort: false
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "createdAt", label: "Tgl. Input" },
                { key: "tipe", label: "Tipe & Eksekutor" },
                { key: "pengerjaan", label: "Tgl. & Lokasi Pengerjaan" },
                { key: "catatan", label: "Catatan", class: "w-50" },
                { key: "aksi", label: "Aksi" }
            ],

            items: [],
            activeItem: null,

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optLog: [
                { value: 0, text: "Catatan" },
                { value: 1, text: "Top Up" },
                { value: 2, text: "Service" },
                { value: 3, text: "Pindah" },
                { value: 4, text: "Status" },
                { value: 5, text: "Tiket" },
                { value: 6, text: "Repair" },
                { value: 7, text: "Overhaul" },
                { value: 8, text: "Plan" },
            ],
            optSort: [
                { value: false, text: 'Dari Terbaru' },
                { value: true, text: 'Dari Terlama' }
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            this.hasVoid = false

            let getItems = this.getItems()

            // Hilangkan aksi bila bukan superadmin
            if(this.roleId != 0 && this.fields.length == 5) {
                this.fields.pop()
            }

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&sortAsc=" + this.filter.sort
            param += "&engineId=" + this.main.id

            if(this.filter.tipeLog.length != 8) { // 8 artinya terpilih semua
                this.filter.tipeLog.forEach(it => {
                    param += "&filterTipe=" + it
                })
            }

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            // Execute
            return this.$axios.get("log/" + param).then(res => {

                console.log(res.data)
                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeVoid() {

            let payload = new FormData()
            payload.append("logId", this.activeItem.id)

            this.isSubmitting = true
            this.$axios.post("log/void", payload).then(res => {

                this.$bvModal.hide("modal-void")
                this.$helper.toastSuccess(this, "Log berhasil divoid!")
                this.hasVoid = true
                this.getItems()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeDownloadExcel() {

            let param = "?engineId=" + this.main.id

            if(this.filter.tipeLog.length != 8) { // 8 artinya terpilih semua
                this.filter.tipeLog.forEach(it => {
                    param += "&filterTipe=" + it
                })
            }

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            // Execute
            this.printStatus = 1
            this.$axios.get("log/excel" + param).then(res => {

                this.excelPath = this.$BASE_FILE_PATH + res.data
                this.printStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.printStatus = 0
            })

        },

        openVoidModal(item) {

            this.activeItem = item
            this.$bvModal.show("modal-void")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        parseBadgeVariantTipe(id) {
            switch(id) {
                case 0: return "dark"
                case 1: return "success"
                case 2: return "danger"
                case 3: return "warning"
                case 4: return "info"
                case 5: return "secondary"
                case 6: return "warning"
                case 7: return "danger"
                case 8: return "success"
                default: return "light"
            }
        },

        checkIfShouldRefresh() {

            if(this.hasVoid) {
                this.$emit("should-refresh")
            }

        },

        isAllowedToDownloadExcel() {
            return [0, 8].includes(this.roleId) // Superadmin dan logistik pusat
        }

    },
    created() {
        this.roleId = Number(localStorage.getItem("roleId"))
    }

}
</script>
